<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Gelir Tanımı
    </div>
    <template v-if="dataItem.donation_group">
      <div>{{ dataItem.donation_group }}</div>
      <div class="text-warning font-small-2">
        {{ dataItem.main_group }}
      </div>
      <b-badge
        variant="light-warning"
      >
        {{ dataItem.donation_type }}
      </b-badge>
    </template>
    <template v-else>
      <div class="text-muted">
        Belirtilmedi
      </div>
    </template>
  </b-list-group-item>
</template>
<script>
import { BBadge, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonationGroup',
  components: {
    BBadge,
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
